export default[
	{
		path: "/solution",
		component: () => import("../../components/main.vue"),
		meta: {
			title: '解决方案'
		},
		children:[
			{
				path:'5Gstations',
				component: () => import("../../components/solution/5Gstations/index.vue"),
				meta: {
					title: '5G基站智能质检'
				}
			},{
				path:'monitorFlood',
				component: () => import("../../components/solution/monitorflood/index.vue"),
				meta: {
					title: '智慧水务防汛监控'
				}
			},{
				path:'operatorToB',
				component: () => import("../../components/solution/batchTOB/index.vue"),
				meta: {
					title: '运营商To B业务批量填单'
				}
			},{
				path:'gatherData',
				component: () => import("../../components/solution/gatherdata/index.vue"),
				meta: {
					title: '风控数据智能化采集'
				}
			},{
				path:'wisdomAffair',
				component: () => import("../../components/solution/wisdomaffair/index.vue"),
				meta: {
					title: '智慧政务审批'
				}
			},{
				path:'travel',
				component: () => import("../../components/solution/travel/index.vue"),
				meta: {
					title: '员工差旅报销'
				}
			},
		]
	}
]
